// ═══════════════════════════════════════════════════════════════════
//  modules/courriel/TagPill.js
//  TagPill
// ═══════════════════════════════════════════════════════════════════

import { MAIL_TAGS } from "./constantes";

export function TagPill({ tag, onClick }) {
  const t = MAIL_TAGS[tag] || MAIL_TAGS.a_trier;
  return (
    <span onClick={onClick} style={{
      background: t.bg, color: t.color, fontSize: 10, fontWeight: 800,
      borderRadius: 999, padding: "2px 9px", letterSpacing: ".05em",
      cursor: onClick ? "pointer" : "default", whiteSpace: "nowrap",
    }}>{t.label.toUpperCase()}</span>
  );
}
